/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_039: Question = {
  id: 'pres-039-liste-especes-exotiques',
  oldId: '53',
  title: 'La liste des espèces exotiques envahissantes présentes sur le territoire est connue',
  number: '4.1',
  description: ['donnée obtenue par le géomaticien du programme'],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  doneByRE: true,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.HECTARE,
    },
  ],
};

const question_pres_039__v3: Question = {
  ...question_pres_039,
  title: 'Consultation de la liste des espèces exotiques envahissantes présentes sur le territoire',
};

export const question_pres_039_v2: Question = question_pres_039;
export const question_pres_039_v3: Question = question_pres_039__v3;
